<template>
    <div class="fst-LlmsList">
        <div class="top">
            <div class="title">
                <span class="mr-2">{{ $t('llms.list.title') }}</span>
                <el-link type="primary" :underline="false" :title="$t('add')" icon="fas fa-plus" @click="$emit('onAdd')" />
            </div>
            <el-link type="primary" :underline="false" :title="$t('update')" icon="fas fa-sync-alt" @click="load()" />
        </div>
        <div class="list">
            <div v-for="item in result.list" :key="item.id" :class="['list-item', {active: item.id === active.id}]">
                <div class="list-item-header" @click="event => handleClickItem(event, item)">
                    <div class="name" :title="item.name">{{ item.name }}</div>
                    <div class="actions">
                        <el-link type="primary" icon="fal fa-trash-alt" @click="handleDelete(item.id)" :underline="false" :title="$t('delete')" />
                    </div>
                </div>
                <div class="list-item-content">
                    <LlmsTemplates v-if="item.id === active.id" :llm="item" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import _ from 'lodash';
    import { mapActions } from 'vuex';
    import utils from '@/commons/utils';
    import LlmsTemplates from './LlmsTemplates.vue';
    function closest(event, classes) {
        if(!event) return false;
        let list = _.isArray(classes) ? classes : [classes];
        return _.some(list, c => event && event.target.closest(c));
    }
    export default {
        name: "LlmsList",
        components: {LlmsTemplates},
        props: {
            active: {
                type: Object,
                default: () => ({})
            }
        },
        data() {
            return {
                result: {
                    offset: 0,
                    total: 0,
                    list: []
                }
            }
        },
        mounted() {
            this.load();
        },
        methods: {
            ...mapActions('llm', ['getLlms','deleteLlm']),
            load() {
                return this.getLlms({prepare: {target: this.$el}}).then(data => {
                    this.result = data;
                    return data;
                });
            },
            handleDelete(id){
                this.$confirm(this.$t('llms.msg.deleteConfirm'), 'Внимание', {
                    confirmButtonText: 'Да',
                    cancelButtonText: 'Отмена',
                    type: 'warning'
                }).then(() => {
                    this.remove(id);
                }).catch(() => {
                });
            },
            remove(id) {
                this.deleteLlm({request: {ids: [id]}, prepare: {target: this.$el}}).then(() => {
                    let index = _.findIndex(this.result.list, ['id', id]);
                    if (index !== -1) {
                        this.result.list.splice(index, 1);
                        this.$emit('afterRemove', id);
                    }
                });
            },
            handleClickItem(event, item) {
                if (closest(event, '.actions')) return;
                this.$emit('onClick', item);
            }
        }
    }
</script>

<style lang="scss">
    @use "@/assets/imports.scss" as *;

    .fst-LlmsList {
        display: flex;
        flex-direction: column;
        overflow: hidden;

        .top {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin: 0 20px 15px 0;
            .title {
                font-weight: bold;
            }
            .buttons {
                margin-left: 10px;
            }
        }

        .list {
            flex: 1;
            padding-right: 20px;
            overflow: hidden;
            overflow-y: auto;
            border-top: 1px solid $iq-border-color-light;
            &-item {
                border-bottom: 1px solid $iq-border-color-light;
                &.active {
                    background-color: hsl(222 91% 97% / 1);
                    box-shadow: inset 1px 1px 5px 0 rgba(0, 0, 0, 0.1);
                    border-radius: 5px;
                    border: 1px solid #acc1fa;
                    .list-item-header {
                        background: hsl(212 71% 88% / 1);
                        font-weight: 500;
                    }
                }
                &-header {
                    display: flex;
                    align-items: center;
                    padding: 10px 12px;
                    cursor: pointer;
                    &:hover {
                        background-color: $iq-border-color-lighter;
                        .actions {
                            opacity: 1;
                        }
                    }
                    .name {
                        flex: 1;
                        display: -webkit-box;
                        -webkit-line-clamp: 2;
                        -webkit-box-orient: vertical;
                        overflow: hidden;
                    }
                    .actions {
                        margin-left: 10px;
                        opacity: 0;
                        transition: all .1s linear;
                        .el-link {
                            font-size: 12px;
                        }
                    }
                }
                &-content {}
            }
        }
    }
</style>
